import { CountryCode } from '../countries';
import type { CountryLanguages } from './country-languages.model';

export interface GenerateCountryLanguagesOptions {
  readonly countryCode?: CountryCode;
  readonly languageCodes?: readonly string[];
}

export interface GenerateCountryLanguagesObjectsOptions {
  readonly countryCodes?: readonly CountryCode[];
}

const DEFAULT_COUNTRY_LANGUAGES: {
  readonly [C in CountryCode]?: readonly string[];
} = {
  [CountryCode.AU]: ['en'],
  [CountryCode.US]: ['en'],
  [CountryCode.GB]: ['en'],
  [CountryCode.ES]: ['es', 'ca'],
  [CountryCode.PH]: ['en', 'fil'],
  [CountryCode.IN]: ['hi', 'en'],
  [CountryCode.FR]: ['fr'],
  [CountryCode.BR]: ['pt'],
};

export function generateCountryLanguagesObject({
  countryCode = CountryCode.AU,
  languageCodes = DEFAULT_COUNTRY_LANGUAGES[countryCode] ?? ['en'],
}: GenerateCountryLanguagesOptions = {}): CountryLanguages {
  return {
    id: countryCode,
    countryCode,
    languageCodes,
  };
}

export function generateCountryLanguagesObjects({
  countryCodes = Object.keys(
    DEFAULT_COUNTRY_LANGUAGES,
  ) as readonly CountryCode[],
}: GenerateCountryLanguagesObjectsOptions = {}): readonly CountryLanguages[] {
  return countryCodes.map(countryCode =>
    generateCountryLanguagesObject({ countryCode }),
  );
}
